import { Modal, ModalProps } from "antd"
import { useTranslation } from "react-i18next"
import { useUnassignExecutionMonitor } from "./queries"
import { useEventId } from "pages/events"

interface Props extends ModalProps {
  data?: string
  onClose: () => void
}

const UnassignMonitorModal: React.FC<Props> = ({ data, ...props }) => {
  const { t } = useTranslation()
  const eventId = useEventId()
  const { mutate, isLoading } = useUnassignExecutionMonitor(eventId!, {
    meta: {
      type: "unassign",
      entity: t("monitors.monitor"),
    },
  })
  const onConfirm = () => {
    mutate(data!, {
      onSuccess() {
        props.onClose()
      },
    })
  }

  return (
    <Modal
      okType="danger"
      okText={t("global.delete")}
      onCancel={props.onClose}
      onOk={onConfirm}
      confirmLoading={isLoading}
      cancelText={t("global.cancel")}
      {...props}
    >
      <p style={{ marginTop: "var(--size-6)" }}>
        {t("global.delete_confirmation")}
      </p>
    </Modal>
  )
}

export default UnassignMonitorModal
